import { api } from 'src/utils/api';
export const appType = 'Validator';
export const barcodeMinLength = 10;
export const taxAmountForDemoMode = 8;

export enum LogLevel {
  // eslint-disable-next-line no-unused-vars
  Trace = 'Trace',
}

export type LogToCloudType = {
  message: string,
  logLevel?: LogLevel,
  Source?: string,
  data?: any;
};

export const randomString = (length) => {
  let result = '';
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  const charactersLength = characters.length;
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() *
      charactersLength));
  }
  return result;
};

export function removeHTML(str) {
  const tmp = document.createElement('DIV');
  tmp.innerHTML = str;
  return tmp.textContent || tmp.innerText || '';
}

export function roundNumber(value: number) {
  return (Math.round(value * 100) / 100).toFixed(2);
}

export const calculateSubTotal = (itemsInBag) => {
  return itemsInBag.reduce(function (accumulator, item) {
    return accumulator + (item.product.price * item.product.quantity || 0);
  }, 0);
};

export const calculateTotal = (subtotal, taxAmount, discounts) => {
  return (subtotal - discounts + (taxAmount || 0));
};

export const handleUpdateStatus = async (stationId, stationStatus) => {
  const { status } = await api(`stations/${stationId}/status/${stationStatus}`, 'patch');
  return status;
};

export const confirmationCompleteTime = {
  min: 5,
  max: 600,
  default: 10
};

export const logToCloud = ({ message = '', data = {}, logLevel = LogLevel.Trace }: LogToCloudType): void => {
  try {
    const requestPayload = {
      logLevel,
      message,
      source: appType,
      data
    };
    api('logging', 'post', requestPayload);
  } catch (e) {
    console.error(e);
  }
};

export const playSound = (url) => {
  const audio = new Audio(url);
  audio.play().then().catch((e) => { console.log('e', e); });
};

export const defaultOptionsForLongPress = { isPreventDefault: true, delay: 1000 };

export const getOnLineStatus = () =>
  typeof navigator !== 'undefined' && typeof navigator.onLine === 'boolean'
    ? navigator.onLine
    : true;

export const truncate = (input, length = 25) => input?.length > length ? `${input.substring(0, length)}...` : input;